/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Meta_DescriptionInputs */

const en_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private golf lessons in Des Moines, Iowa. Full swing, short game, junior development, and launch-monitor sessions.`)
};

const es_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clases privadas de golf en Des Moines, Iowa. Swing completo, juego corto, desarrollo junior y sesiones con launch monitor.`)
};

const de_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privater Golfunterricht in Des Moines, Iowa. Full Swing, kurzes Spiel, Nachwuchsförderung und Training mit dem Launch-Monitor.`)
};

const zh_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州得梅因的私人高尔夫课程。全挥杆、短杆、青少年培养，以及弹道监测仪（launch monitor）课程。`)
};

const ar_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس غولف خاصة في Des Moines، Iowa. الضربة الكاملة، واللعب القصير، وتطوير الناشئين، وجلسات مع جهاز تحليل الضربات.`)
};

const fr_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours de golf particuliers à Des Moines, Iowa. Swing complet, petit jeu, développement junior et séances avec launch monitor.`)
};

const vi_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học golf riêng tại Des Moines, Iowa. Full swing, lối chơi ngắn, đào tạo tài năng trẻ và buổi học với máy đo quỹ đạo (launch monitor).`)
};

const sw_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masomo ya gofu ya binafsi huko Des Moines, Iowa. Swing kamili, mchezo mfupi, maendeleo ya vijana, na vipindi vya launch monitor.`)
};

const th_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนกอล์ฟส่วนตัวในดิมอยน์ ไอโอวา ฟูลสวิง เกมสั้น การพัฒนานักกอล์ฟเยาวชน และเซสชันกับลอนช์มอนิเตอร์`)
};

const bs_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatni časovi golfa u Des Moinesu, Iowa. Puni swing, kratka igra, razvoj juniora i treninzi s launch monitorom.`)
};

const ja_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワ州デモインのプライベートゴルフレッスン。フルスイング、ショートゲーム、ジュニア育成、ローンチモニターを使ったセッション。`)
};

const ko_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이오와주 데모인의 프라이빗 골프 레슨. 풀스윙, 숏게임, 주니어 육성, 론치 모니터 세션.`)
};

const pt_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas particulares de golfe em Des Moines, Iowa. Swing completo, jogo curto, desenvolvimento júnior e sessões com launch monitor.`)
};

const it_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni private di golf a Des Moines, Iowa. Swing completo, gioco corto, sviluppo junior e sessioni con launch monitor.`)
};

const sv_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privata golflektioner i Des Moines, Iowa. Full sving, kort spel, juniorutveckling och lektioner med launch monitor.`)
};

const nl_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privégolflessen in Des Moines, Iowa. Volledige swing, het korte spel, juniorontwikkeling en sessies met een launch monitor.`)
};

const da_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private golflektioner i Des Moines, Iowa. Fuldt sving, det korte spil, juniorudvikling og lektioner med launch monitor.`)
};

const nb_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private golftimer i Des Moines, Iowa. Full sving, kortspill, juniorutvikling og timer med launch monitor.`)
};

const fi_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisiä golftunteja Des Moinesissa, Iowassa. Täysi swing, lähipeli, junioritoiminta ja launch monitor -tunnit.`)
};

const pl_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatne lekcje golfa w Des Moines w stanie Iowa. Pełny swing, krótka gra, rozwój juniorów i sesje z launch monitorem.`)
};

const ru_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальные уроки гольфа в Des Moines, Iowa. Полный свинг, короткая игра, развитие юниоров и занятия с launch monitor.`)
};

const tr_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa'da özel golf dersleri. Tam swing, kısa oyun, genç oyuncu gelişimi ve launch monitor seansları.`)
};

const hi_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में निजी गोल्फ पाठ। फुल स्विंग, शॉर्ट गेम, जूनियर प्रशिक्षण और लॉन्च मॉनिटर के साथ सत्र।`)
};

const id_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les golf privat di Des Moines, Iowa. Ayunan penuh, permainan jarak pendek, pengembangan junior, dan sesi dengan launch monitor.`)
};

const ms_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran golf persendirian di Des Moines, Iowa. Hayunan penuh, permainan jarak dekat, pembangunan pemain junior dan sesi dengan launch monitor.`)
};

const cs_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromé lekce golfu v Des Moines v Iowě. Plný švih, krátká hra, rozvoj juniorů a lekce s launch monitorem.`)
};

const el_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ιδιωτικά μαθήματα γκολφ στο Des Moines της Iowa. Πλήρες σβινγκ, κοντό παιχνίδι, ανάπτυξη νέων παικτών και μαθήματα με launch monitor.`)
};

const he_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורי גולף פרטיים ב-Des Moines, Iowa. סווינג מלא, משחק קצר, פיתוח שחקנים צעירים ומפגשים עם launch monitor.`)
};

const af_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privaat gholflesse in Des Moines, Iowa. Volle swaai, kortspel, juniorontwikkeling en sessies met 'n launch monitor.`)
};

const hu_lessons_meta_description = /** @type {(inputs: Lessons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magán golfórák Des Moinesban (Iowa). Teljes swing, rövid játék, junior képzés és órák launch monitorral.`)
};

/**
* | output |
* | --- |
* | "Private golf lessons in Des Moines, Iowa. Full swing, short game, junior development, and launch-monitor sessions." |
*
* @param {Lessons_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_meta_description = /** @type {((inputs?: Lessons_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_meta_description(inputs)
	if (locale === "de") return de_lessons_meta_description(inputs)
	if (locale === "zh") return zh_lessons_meta_description(inputs)
	if (locale === "ar") return ar_lessons_meta_description(inputs)
	if (locale === "fr") return fr_lessons_meta_description(inputs)
	if (locale === "vi") return vi_lessons_meta_description(inputs)
	if (locale === "sw") return sw_lessons_meta_description(inputs)
	if (locale === "th") return th_lessons_meta_description(inputs)
	if (locale === "bs") return bs_lessons_meta_description(inputs)
	if (locale === "ja") return ja_lessons_meta_description(inputs)
	if (locale === "ko") return ko_lessons_meta_description(inputs)
	if (locale === "pt") return pt_lessons_meta_description(inputs)
	if (locale === "it") return it_lessons_meta_description(inputs)
	if (locale === "sv") return sv_lessons_meta_description(inputs)
	if (locale === "nl") return nl_lessons_meta_description(inputs)
	if (locale === "da") return da_lessons_meta_description(inputs)
	if (locale === "nb") return nb_lessons_meta_description(inputs)
	if (locale === "fi") return fi_lessons_meta_description(inputs)
	if (locale === "pl") return pl_lessons_meta_description(inputs)
	if (locale === "ru") return ru_lessons_meta_description(inputs)
	if (locale === "tr") return tr_lessons_meta_description(inputs)
	if (locale === "hi") return hi_lessons_meta_description(inputs)
	if (locale === "id") return id_lessons_meta_description(inputs)
	if (locale === "ms") return ms_lessons_meta_description(inputs)
	if (locale === "cs") return cs_lessons_meta_description(inputs)
	if (locale === "el") return el_lessons_meta_description(inputs)
	if (locale === "he") return he_lessons_meta_description(inputs)
	if (locale === "af") return af_lessons_meta_description(inputs)
	if (locale === "hu") return hu_lessons_meta_description(inputs)
	return en_lessons_meta_description(inputs)
});